import { render, staticRenderFns } from "./contact-popup.vue?vue&type=template&id=5f223cd3&"
import script from "./contact-popup.vue?vue&type=script&lang=ts&"
export * from "./contact-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports